import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BaseSearch } from '../base-search';
import { SearchBaseRequest } from '../../../models/search/search-base-request';
import { SearchBaseResponse } from '../../../models/search/search-base-response';
import { SearchPaging } from '../../../models/search/search-paging';

@Component({
    selector: 'search-paging',
    templateUrl: './search-paging.component.html',
    styleUrls: ['./search-paging.component.scss'],
    standalone: false
})
export class SearchPagingComponent {
    
    @Input()
    public search: BaseSearch<SearchBaseRequest, SearchBaseResponse<any>>;

    @Input()
    public sizes: number[] = [10, 20, 50, 100];

    public isLoading: boolean = false;

    public get isReady() {
            return this.search && this.search.requestModel && this.search.requestModel.paging && this.search.viewModel;
    }

    public get paging(): SearchPaging {
            return this.search.requestModel.paging;
    }

    public get total() {
            return this.search.viewModel.total;
    }

    public get recordCount() {
            return this.search.viewModel.records ? this.search.viewModel.records.length : null;
    }

    public get isNextPageAvailable() {
            return this.search.viewModel.isNextPageAvailable;
    }

    @Output()
    public onStartChange = new EventEmitter<number>();

    @Output()
    public pagingChanged = new EventEmitter<any>();


    public get startFrom(): number {
            const from = ((this.paging.currentPage || 0) * this.paging.pageSize) + 1;

        return from;
    }

    public get endTo(): number {
            return ((this.startFrom + (this.recordCount || 0)) - 1);
    }

    public onPageSizeChanged($event: any): void {
            $event.stopPropagation();

        this.paging.currentPage = 0;

        this.search.onPagingChanged();
    }

    public onRequestTotal($event) {
            $event.stopPropagation();

        this.isLoading = true;
        this.search.requestTotalAsync().finally(() => {
                this.isLoading = false;
        })
    }

    public onFirst($event): void {
            $event.stopPropagation();

        this.paging.currentPage = 0;

        this.search.onPagingChanged();
    }

    public onPrevious($event): void {
            $event.stopPropagation();

        --this.paging.currentPage;

        this.search.onPagingChanged();
    }

    public onNext($event): void {
            $event.stopPropagation();

        if (!this.isNextPageAvailable) {
                return;
        }

        if (this.paging.currentPage) {
                ++this.paging.currentPage;
        }
        else {
                this.paging.currentPage = 1;
        }

        this.search.onPagingChanged();
    }

    public onLast($event): void {
            $event.stopPropagation();

        if (!this.isNextPageAvailable || !this.total) {
                return;
        }

        this.paging.currentPage = Math.ceil(this.total / this.paging.pageSize) - 1;


        this.search.onPagingChanged();
    }
}